



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import { IModalConfig } from '@/contract/modal.contract';

@Component({ components: { BModal } })
export default class BaseModal<T = any> extends Vue {
  @Prop()
  public modalConfig!: IModalConfig;

  @Prop()
  public modalContext!: T;

  @Prop()
  public visible!: boolean;

  public get bodyIsString(): boolean {
    return typeof this.resultingModalConfig.body === 'string';
  }

  protected defaultConfig: Required<IModalConfig> = {
    centered: true,
    title: '',
    body: '',
    size: 'default',
  };

  public get resultingModalConfig(): Required<IModalConfig> {
    return Object.assign(this.defaultConfig, this.modalConfig);
  }
}
